"use strict";
/**
 * Unit used for tasks effort calculation
 */
Object.defineProperty(exports, "__esModule", { value: true });
